import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { CustomProductSpecHeader } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomProductSpecHeaderService extends TmsWebBaseEditService<
  CustomProductSpecHeader,
  CustomProductSpecHeader
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('CustomProductSpecHeader', $localize`Custom Product Spec Header`);
  }
}
